import { useState, useEffect } from 'react';

const useExtractText = (data: Presentation.Data.TextBody | undefined) => {
  const [text, setText] = useState('');

  useEffect(() => {
    const extractTextFromNode = (
      node: Presentation.Data.ParagraphShape | Presentation.Data.RunShape,
    ): string => {
      if (node.type === 'run') {
        return node.childNodes?.map((child) => child.content).join('') || '';
      } else if (node.type === 'p' && node.childNodes) {
        return node.childNodes.map(extractTextFromNode).join('');
      }
      return '';
    };

    if (data && data.childNodes) {
      const textContent = data.childNodes.map(extractTextFromNode).join(' ');
      setText(textContent);
    }
  }, [data]);

  return text;
};

export default useExtractText;
